import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import useCity from "hooks/useCity";
import useArea from "hooks/useArea";
import { useGetVendorsDropdown } from "hooks/useVendors";
import { useCreateDeliveryOffer } from "hooks/useDeliveryOffers";
import DeliveryOfferForm from "../DeliveryOfferForm/DeliveryOfferForm";
import { emptyOfferForm, formToBody, validateOfferForm } from "../deliveryOfferModel";

const AddDeliveryOffer = (props) => {
    const adminInfo = useSelector((state) => state.auth.userData);
    const { cities } = useCity();
    const { areas } = useArea();
    const { vendors } = useGetVendorsDropdown();
    const createOffer = useCreateDeliveryOffer();

    // An admin of one city makes offers in that city only. The API takes the
    // city from the session for them.
    const ownCity = adminInfo?.super_admin ? "" : adminInfo?.cityId;
    const [form, setForm] = useState(
        () => props.start?.form ?? emptyOfferForm({ cityId: ownCity }),
    );
    const change = (patch) => setForm((current) => ({ ...current, ...patch }));

    // The page opens the form with a ready offer (`props.start`): the form
    // takes its fields. A new object is a new start, also for the same offer.
    useEffect(() => {
        if (props.start?.form) {
            setForm(props.start.form);
        }
    }, [props.start]);

    const vendorOptions = form.cityId
        ? vendors
              .filter((vendor) => +vendor.cityId === +form.cityId)
              .map((vendor) => ({ value: vendor.id, label: vendor.name }))
        : [];

    const areaOptions = form.cityId
        ? (areas ?? [])
              .filter((area) => +area.cityId === +form.cityId)
              .map((area) => ({ value: area.id, label: area.name }))
        : [];

    const submitHandler = async (e) => {
        e.preventDefault();

        const problem = validateOfferForm(form, { needsCity: true });
        if (problem) {
            props.showMessage("error", "هناك خطأ", problem);
            return;
        }

        try {
            await createOffer.mutateAsync(formToBody(form, { withCity: true }));

            props.showMessage("success", "تمت الاضافه", "تمت إضافه العرض بنجاح");
            setForm(emptyOfferForm({ cityId: ownCity }));
            props.close();
        } catch (err) {
            console.error("Error adding delivery offer:", err);
            props.showMessage(
                "error",
                "هناك خطأ",
                err.response?.data?.message || "حدث خطأ غير متوقع",
            );
        }
    };

    return (
        <DeliveryOfferForm
            show={props.show}
            close={props.close}
            title="إضافه عرض توصيل"
            submitLabel="إضافه"
            pending={createOffer.isPending}
            form={form}
            onChange={change}
            onSubmit={submitHandler}
            vendorOptions={vendorOptions}
            areaOptions={areaOptions}
            cities={adminInfo?.super_admin ? (cities ?? []) : undefined}
        />
    );
};
export default AddDeliveryOffer;
